import { TEditCommunityFeesForm } from '../../../../../../components/Forms/forms.editCommunityFees.d'
import { LedByCommunityGroup } from '../types'

export const prepareFormData = (
  data: LedByCommunityGroup[]
): TEditCommunityFeesForm => ({
  gpo_allocation: data[0].gpo_allocation,
  health_systems: data.length > 1 ? data[0].rows : data.flatMap((i) => i.rows)
})
